import React from 'react';
import { BarChart } from '@dsi/react-eds';
import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import styles from './AveragePipelineTimeByStage.module.css';
import { useAveragePipelineTimeByStage, AveragePipelineTimeByStages } from './../hooks/use-average-pipeline-time-by-stage';

interface AveragePipelineTimeByStageProps {
  startDate: string;
  endDate: string;
  onMaximize?: () => void;
  isMaximized?: boolean;
}

const AveragePipelineTimeByStage: React.FC<AveragePipelineTimeByStageProps> = ({ startDate, endDate }) => {
  const { data, isLoading, isError } = useAveragePipelineTimeByStage(startDate, endDate);
  const chartKey = `${startDate}-${endDate}`;

  return (
    <div>
      {/* <div className={styles.titleArea}>
        <label>
          Average Pipeline Time by Stage
          <ReactEDSWrapper component={Tooltip} message="Average time spent per stage (in minutes)" pointer>
            <span className={styles.infoIcon}>
              <i className="icon icon-info" />
            </span>
          </ReactEDSWrapper>
        </label>
        <ReactEDSWrapper component={Button} iconOnly={true} icon={isMaximized ? 'minimize' : 'maximize'} onClick={onMaximize} />
      </div> */}

      {isLoading && <div className={styles.loadingText}>Loading average pipeline time data...</div>}
      {isError && <div className={styles.loadingText}>Error while loading average pipeline time data.</div>}

      {data &&
        (() => {
          if (data.length === 0) {
            return (
              <div className={styles.noDataContainer}>
                <i className={`icon icon-failed ${styles.dangerIcon}`} />
                <div className={styles.noDataTitle}>Data Unavailable</div>
                <div className={styles.noDataSubtitle}>No pipeline time data available for the selected time range</div>
              </div>
            );
          }

          const seriesData = data.map((s: AveragePipelineTimeByStages) => {
            return { name: s.stage, values: [s.avg_duration_minutes] };
          });
          const chartData = {
            common: ['Stages'],
            series: seriesData
          };
          return (
            <div className={styles.chartContainer}>
              <ReactEDSWrapper
                key={chartKey}
                component={BarChart}
                id={`average-pipeline-time-chart-${chartKey}`}
                data={chartData}
                vertical={true}
                grouped={true}
                barWidth={15}
                height={300}
                y={{ unit: 'Minutes' }}
              />
            </div>
          );
        })()}
    </div>
  );
};

export default AveragePipelineTimeByStage;
